<template>
  <div class="publications-block html-content">
    <div class="publications-head">
      <h1>{{ title }}</h1>

      <vue-client-only>
        <a v-if="link" href="/news">
          <template v-if="adaptive.isMobile">
            Все
          </template>
          <template v-else>
            Все новости
          </template>
        </a>
      </vue-client-only>
    </div>

    <vue-client-only>
      <div
        v-if="!adaptive.isMobile"
        class="publications-list"
      >
        <publication-card
          v-for="publication in PUBLICATIONS"
          :key="publication.id"
          :info="publication"
          @click.native="openPublication(publication.id)"
        />
      </div>
      <swiper
        v-else
        dots
        :items="PUBLICATIONS"
        v-slot="{ item }"
        :slides-to-show="1"
      >
        <publication-card
          :info="item"
        />
      </swiper>
    </vue-client-only>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VueClientOnly from 'vue-client-only';

import PublicationCard from './publication-card';


export default {
  name: 'publications-block',

  components: {
    PublicationCard,
    VueClientOnly,
  },

  inject: ['adaptive'],

  props: {
    title: {
      type: String,
      required: true
    },

    link: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      PUBLICATIONS: 'publications/publications',
    })
  },

  methods: {
    ...mapActions({
      LOAD_PUBLICATIONS: 'publications/loadPublications'
    }),

    openPublication(id) {
      window.location = `/news/${id}`;
    },
  },

  serverPrefetch() {
    return this.LOAD_PUBLICATIONS({pageSize: 3});
  }
};
</script>

<style lang="scss">
.publications-block {
  margin-bottom: -48px;

  .publications-head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > a {
      align-self: flex-end;
      font-size: 14px;
      line-height: 16px;
      font-weight: bold;
    }
  }

  & > .publications-list {
    display: flex;
    flex-direction: column;
  }
}

@include breakpoint("tablet") {
  .publications-block {
    .publications-list {
      flex-direction: row;
    }

    .publication-card {
      width: calc(100% - 10px);
      margin-right: 16px;
    }

    .publication-card:last-child {
      margin-right: 0;
    }
  }
}

@include breakpoint("desktop") {
  .publications-block {
    margin-bottom: -64px;

    .publications-head {
      & > a {
        font-size: 20px;
        line-height: 28px;
      }
    }

    .publication-card {
      width: calc(100% - 16px);
      margin-right: 24px;
    }
  }
}
</style>